import React from 'react';
import { connect } from 'react-redux';

import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';
import { pushParams, resetParams } from 'dpl/actions/query_params';
import UserAuthModal from 'dpl/components/UserAuthModal';


const {
  BREEDER_SIGNUP,
  FORGOT_PASSWORD,
  LOGIN,
  SIGNUP
} = SIGNUP_FORM_TYPES;

function UserAuthModalContainer(props) {
  return <UserAuthModal { ...props } />;
}

export default connect(
  (({ queryParams }) => ({ queryParams })),
  {
    onBreederSignupClick() { return pushParams({ direct_signup: BREEDER_SIGNUP }); },
    clearParams() { return resetParams('direct_signup'); },
    onLoginClick() { return pushParams({ direct_signup: LOGIN }); },
    onPasswordResetClick() { return pushParams({ direct_signup: FORGOT_PASSWORD }); },
    onSignupClick() { return pushParams({ direct_signup: SIGNUP }); }
  }
)(UserAuthModalContainer);
